import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useSearchResultCardContext } from './SearchResultCardProvider';

import styles from './SearchResultCardContent.module.css';

export const SearchResultCardApproximateLocation = () => {
  const { isApproximateLocation, translationResolver: t, variant } = useSearchResultCardContext();

  if (variant !== 'preview' || !isApproximateLocation) return null;

  return <Copy className={styles.approximateLocationInfo} size="m" text={t('search.map.placement.approximate')} />;
};
